import RecoveryPassword from './RecoveryPassword';

export default RecoveryPassword;
